import { trpc } from "#/lib/trpc/client"
import { usePreVisitTracking } from "./usePreVisitTracking"
import { HealthieAnswer } from "@internal/telemedicine"
import { useMutation, type UseMutationResult } from "@tanstack/react-query"
import { v4 as uuid } from "uuid"

type SubmitIntakeFormVariables = { formId: string; answers: HealthieAnswer[] }
type SubmitIntakeFormData = Awaited<ReturnType<typeof trpc.telemedicine.submitForm.mutate>>

export function useSubmitIntakeForm(
  appointmentId: string
): UseMutationResult<SubmitIntakeFormData, Error, SubmitIntakeFormVariables> {
  const { trackSubmissionAttempt } = usePreVisitTracking()
  return useMutation({
    mutationFn: async ({ formId, answers }: SubmitIntakeFormVariables) => {
      // A request-scoped ID pairs outcomes with attempts and keeps rapid retries distinct for action deduplication.
      const trackSuccess = trackSubmissionAttempt(uuid())
      const response = await trpc.telemedicine.submitForm.mutate({ appointmentId, formId, answers })
      trackSuccess()
      return response
    }
  })
}
